import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ViewIcon from '@mui/icons-material/Visibility';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Detail from '../Detail';
import * as selectors from '../selector';

import { HistoryController } from './historyController';

import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';
import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';

import AdditionalLoading from '@/components/AdditionalLoading';
import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import TableBase from '@/components/TableBase';

/**
 * プロパティ
 */
export type Props = {
  /** カテゴリ */
  category: PrivateBlogCategoryJson,
  /** 閉じる */
  close: () => void,
};

const History: React.FC<Props> = ({ category, close }) => {
  const dispatch = useDispatch();
  const [
    detailPrivateBlogJson,
    setDetailPrivateBlogJson,
  ] = React.useState<PrivateBlogJson | undefined>(undefined);
  const nurseryId = useSelector(selectors.nurseryIdSelector);
  const categoryItems = useSelector(selectors.categoryItemsSelector);
  const content: ContentJson | undefined = useSelector(selectors.contentSelector);
  const controller = new HistoryController(dispatch, category, categoryItems, nurseryId);
  const actionDetail = controller.getActionDetail(setDetailPrivateBlogJson);
  const { rows, columns } = controller;
  const actions = [
    {
      icon: <ViewIcon />,
      title: '読む',
      action: controller.getActionView(setDetailPrivateBlogJson),
    },
  ];
  return (
    <>
      {detailPrivateBlogJson && content && (
        <Detail
          privateBlog={detailPrivateBlogJson}
          content={content}
          category={category.category}
          publishDate={detailPrivateBlogJson.publishDatetime}
          close={() => actionDetail(undefined)}
        />
      )}
      <Dialog
        open
        onClose={close}
        fullScreen
        TransitionComponent={DialogTransition}
      >
        <DialogTitle title={category.category} />
        <DialogContent>
          <h3>
            <Tooltip title="戻る">
              <IconButton size="large" onClick={close}>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <span>過去の記事</span>
          </h3>
          <TableBase
            rows={rows}
            columns={columns}
            actions={actions}
            refreshAction={controller.getActionRefreshItem()}
            isPagination={false}
            isShowFooter={false}
            isShowFilter={false}
          />
          <AdditionalLoading
            isEnableLoading={controller.getIsEnableLoading()}
            onClick={controller.getActionGetItem()}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={close}
            color="primary"
            variant="contained"
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default History;
